import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Button } from "react-bootstrap";
import { Main, ContenedorDatos, ContenedorFechas, ContenedorTitulo, Tarjeta, TituloDispositivo } from "../Historico/ElementosStyles";
import SankeyChart from "../Historico/Widgets/Sankey/SankeyChart";

const GeneralSanFelipe = () => {
    const history = useHistory();
    const data = {
        nodes: [
            { name: "Central" },
            { name: "TDP-1" },
            { name: "BK-1" },
            { name: "BK-2" },
            { name: "BK-3" },
            { name: "BK-4" },
            { name: "BK-5" },
            { name: "BK-6" },
            { name: "TDP-2" },
            { name: "BK-1" },
            { name: "BK-2" },
            { name: "BK-3" },
            { name: "BK-4" },
            { name: "BK-5" },
            { name: "BK-6" }
        ],
        links: [
            { source: 0, target: 1, value: 1 },
            { source: 0, target: 8, value: 1 },
            { source: 1, target: 2, value: 1 },
            { source: 1, target: 3, value: 1 },
            { source: 1, target: 4, value: 1 },
            { source: 1, target: 5, value: 1 },
            { source: 1, target: 6, value: 1 },
            { source: 1, target: 7, value: 1 },
            { source: 8, target: 9, value: 1 },
            { source: 8, target: 10, value: 1 },
            { source: 8, target: 11, value: 1 },
            { source: 8, target: 12, value: 1 },
            { source: 8, target: 13, value: 1 },
            { source: 8, target: 14, value: 1 }
        ]
    };

    return (
        <>
            <Main>
                <ContenedorFechas>
                    <Button onClick={() => { history.goBack() }}>Atras</Button>
                </ContenedorFechas>
                <ContenedorTitulo>General</ContenedorTitulo>
                <>
                    <Tarjeta>
                        <TituloDispositivo>Consumo de Energía</TituloDispositivo>
                        <SankeyChart data={data} width={800} height={500} />
                    </Tarjeta>
                </>
            </Main>
        </>
    );
}

export default GeneralSanFelipe;
